export default {
  'modals': {
    'edit-hours': {
      'apply-changes-starting': 'Make changes effective:',
      'edit-business-opening-hours': 'Edit • Business Hours',
      'edit-opening-hours': 'Edit • Business Hours • {date}',
      'edit-working-hours': 'Edit • Working Hours • {name}',
      'edit-shift': 'Edit shift • {name} • {date}',
      'hint': 'The changes you are about to save will replace opening hours change scheduled on {date}',
    },
    'time-off': {
      'time-off': 'Time Off',
      'edit-time-off': 'Edit Time Off',
      'add-time-off': 'Add Time Off',
      'select-type': 'Select type',
      'select-date': 'Select date',
      'start-date': 'Start date',
      'end-date': 'End date',
      'day-duration': '{count} day | {count} days | {count} days',
      'choose-staffer': 'Choose staffer',
      'reason': 'Reason',
      'approved': 'Approved',
      'all-day': 'All Day',
      'date': 'Date',
      'repeat-each-day-till': 'Repeat each day till',
      'repeat': 'Repeat',
      'approved-hint': 'If you select the checkbox, the time off will be validated and included in the staff member\'s working hours.',
      'clear-time-off': 'Clear time off',
      'reason-code-required': 'Time off reason is required.',
      'resource-ids-required': 'At least one staff member is required.',
    },
    'shifts-copy': {
      'title': 'Copy Shifts',
      'use-from': 'Use shifts from selected',
      'apply-to-weeks': 'Apply to selected weeks',
      'apply-to-days': 'Apply to selected days',
      'week': 'Week',
      'date': 'Date',
      'for-staff-members': 'For selected staff members',
      'for-resources': 'For selected resources',
      'apply': 'Apply',
      'week-number': 'Week #{weekNumber} • {weekInfo}',
      'week-number-transition': 'Week #{startWeek} / Week #{endWeek}',
      'shifts-duplicated': 'Shifts duplicated',
    },
  },
  'shifts-board': {
    'time-off': 'time off',
    'add-time-off': 'Add Time Off',
    'working-hours-applied-date': 'New working hours will be applied on {date}',
    'opening-hours-applied-date': 'New business hours will be applied on {date}',
    'remove-time-off': 'Remove Time Off?',
    'remove-time-off-description': 'This action cannot be undone',
    'hint': 'The changes you are about to save will replace opening hours change scheduled on {date}',
    'warning-title': 'Adjust Opening Hours?',
  },
  'shifts-opening-hours': {
    'opening-hours': 'Business Hours',
    'edit': 'Edit',
    'week': 'W',
    'month': 'M',
    'day': 'D',
    'closed': 'Closed',
    'break': 'break',
    'warning-hint': 'You have empty shifts for this day. Please review staffers working hours and adjust them so that at least one staffer is present during business working hours.',
  },
  'shifts-print': {
    'break': 'Break',
    'absence': 'absence',
    'no-shift': 'No Shift',
  },
  'shifts-sources': {
    'edit': 'Edit',
    'day': 'D',
    'week': 'W',
    'month': 'M',
    'edit-working-hours': 'Edit working hours',
    'add-time-off': 'Add time off',
  },
  'shifts-view': {
    'break': 'break',
    'absence': 'absence',
    'no-shift': 'No Shift',
    'time-off': 'Time Off',
  },
  'resource-picker': {
    'all': 'All',
  },
}
